import { useEffect } from 'react';

import { useScrollContext } from 'state/scroll';

/**
 * This custom hook was made to be used on pages that require the main ScrollView component
 * to be full height, so that the content inside can take up all the available vertical space.
 */
export const useScrollViewFullHeight = (skipEffect?: () => boolean) => {
  const { setHasScrollFullHeight } = useScrollContext();

  useEffect(() => {
    if (skipEffect?.()) {
      return;
    }

    setHasScrollFullHeight(true);

    return () => {
      setHasScrollFullHeight(false);
    };
  }, []);
};
